/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The IntegrationsashWellnessAshWellnessIntegration model module.
 * @module model/IntegrationsashWellnessAshWellnessIntegration
 * @version v0.3
 */
export default class IntegrationsashWellnessAshWellnessIntegration {
  /**
   * Constructs a new <code>IntegrationsashWellnessAshWellnessIntegration</code>.
   * @alias module:model/IntegrationsashWellnessAshWellnessIntegration
   * @class
   * @param partnerId {String} 
   * @param accessToken {String} 
   */
  constructor(partnerId, accessToken) {
    this.partnerId = partnerId;
    this.accessToken = accessToken;
  }

  /**
   * Constructs a <code>IntegrationsashWellnessAshWellnessIntegration</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsashWellnessAshWellnessIntegration} obj Optional instance to populate.
   * @return {module:model/IntegrationsashWellnessAshWellnessIntegration} The populated <code>IntegrationsashWellnessAshWellnessIntegration</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsashWellnessAshWellnessIntegration();
      if (data.hasOwnProperty('partner_id'))
        obj.partnerId = ApiClient.convertToType(data['partner_id'], 'String');
      if (data.hasOwnProperty('access_token'))
        obj.accessToken = ApiClient.convertToType(data['access_token'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} partnerId
 */
IntegrationsashWellnessAshWellnessIntegration.prototype.partnerId = undefined;

/**
 * @member {String} accessToken
 */
IntegrationsashWellnessAshWellnessIntegration.prototype.accessToken = undefined;

/**
 * @member {Boolean} enabled
 * @default true
 */
IntegrationsashWellnessAshWellnessIntegration.prototype.enabled = true;

